import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 25px;
  padding: 40px 20px;
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  background-color: ${({ theme }) => theme.palette.primary.background};
  border: 1px solid ${({ theme }) => theme.palette.secondary.border};
  border-radius: 14px;
  box-shadow: -5px -5px 12px 0 rgba(19, 19, 19, 0.02),
    5px 5px 12px 0 rgba(19, 19, 19, 0.02);
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  padding: 20px 30px;
  border-radius: 100px;
  background-color: ${({ theme }) => theme.palette.secondary.background};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

export const Title = styled(Typography.Title)`
  text-align: center;
`;
